import {MissionDao} from '../../dao';
import {ErrorModel, MissionModel} from '../../models';
import { Mission } from '../../models/mission/mission';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_ALL_MISSIONS';

export async function getAllMissions(
    userData: Record<string, string>,
    params: string,
    page: number
) {
    try {

        const result = await MissionDao.getAllMissions(userData, params, page);

        const parsedResult: Mission[] = result.results.map((mission: any) => MissionModel.parseMission(mission));

        const metadata = {
            count: result.count,
            next: result.next,
            previous: result.previous
        };

        return {
            metadata,
            data: parsedResult
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des affaires',
            error: error
        });
    }
}
